import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TopToolbar,
  CreateButton, 
  EditButton,
} from 'react-admin';

import LessonListFilter from './LessonListFilter';

const LessonListActions = () => {
  return (
    <TopToolbar>
        <CreateButton
          basePath="/lessons"
          variant="contained"
          label="New Lesson"
        />
    </TopToolbar>
  );
};

const LessonList = (props) => {
  return (
    <List
      {...props}
      actions={<LessonListActions />}
      aside={<LessonListFilter />}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="raw_name" label="Nome genérico" />
        <TextField source="xp" />
        <TextField source="access" />
        <EditButton />
      </Datagrid>
    </List>
  );
}

export default LessonList;